import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';
import { cn } from '@root/src/utils/cn';

interface GuestLegalBarProps {
  className?: string;
}

/**
 * Legal bar for unauthenticated visitors, rendered on pages with no footer.
 *
 * Two call sites: the guest job list (`pages/[locale]/job/list/[[...slug]].tsx`), which
 * `/` redirects to and is therefore the page Google's check lands on, and the Bestie chat
 * (`BestieChatView.tsx`), which carried the homepage for a while and keeps its bar in case
 * it does again. Its Terms & Privacy links must be present in the initial server HTML —
 * required for crawlers and Google's OAuth homepage check, which is a human loading the
 * page logged out and never opening menus. Transparent background.
 *
 * Deliberately quiet, but must stay human-visible: the OAuth check is a human
 * reviewer loading the page — CSS-hiding the links would fail it.
 */
export const GuestLegalBar = ({ className }: GuestLegalBarProps) => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <div
      className={cn(
        'flex w-full flex-row items-center justify-between gap-3 pb-0 pt-1.5 text-left',
        className,
      )}
    >
      <span className="whitespace-nowrap text-[10px] uppercase text-ink/50">
        {`© ${currentYear} BESTJOBS RECRUTARE SA`}
      </span>
      <div className="flex items-center gap-3">
        <LinkStyled href="/legal/terms" size="xs" styling="text" color="ink" className="whitespace-nowrap text-[10px] !text-ink/50 hover:!text-ink md:text-xs">
          {t('menu.conditions')}
        </LinkStyled>
        <LinkStyled href="/legal/confidentiality" size="xs" styling="text" color="ink" className="whitespace-nowrap text-[10px] !text-ink/50 hover:!text-ink md:text-xs">
          {t('menu.confidentiality')}
        </LinkStyled>
      </div>
    </div>
  );
};
